import { IConfig } from './index';
import {
  REACT_APP_MIVA_BACKOFFICE_ENDPOINT,
  REACT_APP_API_HOST,
} from '@/config/development';

const CONFIG: IConfig = {
  API: {
    ROOT_ENDPOINT: `${REACT_APP_API_HOST}`,
    BACKOFFICE_ENDPOINT: `${REACT_APP_MIVA_BACKOFFICE_ENDPOINT}`,
  },
  API_SESSIONS_PATH: {
    START_SESSION: '/sessions/start',
    END_SESSION: '/sessions/:id/end',
    PING_SESSION: '/sessions/:id/ping',
    DELETE_SESSION: '/sessions/:id',
    SESSIONS: '/sessions',
    SESSIONS_ACTIVE: '/sessions/active',
  },
  API_ACTIVITIES_PATH: {
    ACTIVITIES: '/activities',
  },
  API_BACKOFFICE_PATH: {
    VERIFY_COURSE: `${REACT_APP_MIVA_BACKOFFICE_ENDPOINT}/courses/public/course-code/:courseCode`,
  },
};

export default CONFIG;
